/* Huis & Haveli — theme scripts */
(function () {
  'use strict';

  /* Side menu drawer */
  (function () {
    var drawer = document.getElementById('MenuDrawer');
    if (!drawer) return;
    var panel = drawer.querySelector('.drawer__panel');
    var openers = document.querySelectorAll('[data-drawer-open]');
    var lastFocus = null;
    function focusables() {
      return Array.prototype.slice.call(panel.querySelectorAll('a[href],button,summary')).filter(function (el) { return el.offsetParent !== null; });
    }
    function open() {
      lastFocus = document.activeElement;
      drawer.hidden = false;
      void drawer.offsetWidth;
      drawer.classList.add('is-open');
      document.body.classList.add('drawer-open');
      openers.forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
      var f = focusables(); (f[0] || panel).focus();
    }
    function close() {
      drawer.classList.remove('is-open');
      document.body.classList.remove('drawer-open');
      openers.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      setTimeout(function () { drawer.hidden = true; }, reduce ? 0 : 300);
      if (lastFocus) lastFocus.focus();
    }
    openers.forEach(function (b) { b.addEventListener('click', open); });
    drawer.querySelectorAll('[data-drawer-close]').forEach(function (b) { b.addEventListener('click', close); });
    drawer.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { close(); return; }
      if (e.key !== 'Tab') return;
      var f = focusables(); if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  })();

  /* Carousel */
  function initCarousel(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    var track = root.querySelector('.carousel__track');
    var slides = Array.prototype.slice.call(root.querySelectorAll('.slide'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('.carousel__dot'));
    var count = root.querySelector('.carousel__count');
    var n = slides.length;
    if (!track || n === 0) return;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var auto = root.dataset.autoplay === 'true' && !reduce && n > 1;
    var i = 0, hover = false, focus = false;
    root.style.setProperty('--dur', (parseInt(root.dataset.speed, 10) || 6500) + 'ms');
    if (!auto) root.classList.add('is-static');
    function pad(x) { return (x < 10 ? '0' : '') + x; }
    function go(k, user) {
      i = (k + n) % n;
      track.style.transform = 'translateX(' + (-100 * i) + '%)';
      slides.forEach(function (s, idx) {
        var on = idx === i;
        s.setAttribute('aria-hidden', String(!on));
        s.querySelectorAll('a,button').forEach(function (a) { a.tabIndex = on ? 0 : -1; });
      });
      dots.forEach(function (d, idx) {
        d.removeAttribute('aria-current');
        if (idx === i) { void d.offsetWidth; d.setAttribute('aria-current', 'true'); }
      });
      if (count) count.textContent = pad(i + 1) + ' / ' + pad(n);
      track.setAttribute('aria-live', user ? 'polite' : 'off');
      sync();
    }
    function sync() { root.classList.toggle('is-paused', hover || focus || document.hidden); }
    if (auto) {
      dots.forEach(function (d) {
        d.addEventListener('animationend', function () {
          if (d.getAttribute('aria-current') === 'true') go(i + 1);
        });
      });
    }
    var prev = root.querySelector('[data-prev]'), next = root.querySelector('[data-next]');
    if (prev) prev.addEventListener('click', function () { go(i - 1, true); });
    if (next) next.addEventListener('click', function () { go(i + 1, true); });
    dots.forEach(function (d, idx) { d.addEventListener('click', function () { go(idx, true); }); });
    /* Keep slides moving after clicks and taps. Only pause on hover when the
       section setting asks for it (and only for a real mouse), and only pause
       for focus when someone is navigating with the keyboard. */
    if (root.dataset.pauseHover === 'true') {
      root.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') { hover = true; sync(); } });
      root.addEventListener('pointerleave', function () { hover = false; sync(); });
    }
    root.addEventListener('focusin', function (e) {
      var t = e.target;
      var kb = false;
      try { kb = t && t.matches && t.matches(':focus-visible'); } catch (err) { kb = false; }
      focus = !!kb; sync();
    });
    root.addEventListener('focusout', function () { focus = false; sync(); });
    root.addEventListener('pointerdown', function () { if (focus) { focus = false; sync(); } });
    document.addEventListener('visibilitychange', sync);
    /* Centre the side arrows on the photo (it sits above the text on phones). */
    var firstArch = slides[0] && slides[0].querySelector('.arch');
    function placeArrows() {
      if (!firstArch) return;
      var r = root.getBoundingClientRect(), a = firstArch.getBoundingClientRect();
      if (!a.height) return;
      root.style.setProperty('--arrow-y', Math.round(a.top - r.top + a.height / 2) + 'px');
    }
    placeArrows();
    window.addEventListener('resize', placeArrows);
    window.addEventListener('load', placeArrows);
    if (window.ResizeObserver && firstArch) new ResizeObserver(placeArrows).observe(firstArch);
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') go(i - 1, true);
      if (e.key === 'ArrowRight') go(i + 1, true);
    });
    var x0 = null;
    track.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    track.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) go(dx < 0 ? i + 1 : i - 1, true);
      x0 = null;
    });
    go(0);
  }

  /* Tabs */
  function initTabs(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
    tabs.forEach(function (t, idx) {
      t.addEventListener('click', function () { select(idx); });
      t.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { select((idx + 1) % tabs.length); tabs[(idx + 1) % tabs.length].focus(); }
        if (e.key === 'ArrowLeft') { select((idx - 1 + tabs.length) % tabs.length); tabs[(idx - 1 + tabs.length) % tabs.length].focus(); }
      });
    });
    function select(k) {
      tabs.forEach(function (t, idx) {
        var on = idx === k;
        t.setAttribute('aria-selected', String(on));
        t.tabIndex = on ? 0 : -1;
        var p = document.getElementById(t.getAttribute('aria-controls'));
        if (p) p.hidden = !on;
      });
    }
  }


  var HH = window.HH || { cartType: 'page', routes: {}, strings: {} };
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Simple modal helper: focus trap, Escape, restore focus */
  function modal(el, panel, onClose) {
    var last = null;
    function focusables() {
      return Array.prototype.slice.call(panel.querySelectorAll('a[href],button:not([disabled]),input:not([type="hidden"]),select,textarea,summary,[tabindex]:not([tabindex="-1"])'))
        .filter(function (x) { return x.offsetParent !== null; });
    }
    function key(e) {
      if (e.key === 'Escape') { close(); return; }
      if (e.key !== 'Tab') return;
      var f = focusables(); if (!f.length) return;
      var first = f[0], lastEl = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); lastEl.focus(); }
      else if (!e.shiftKey && document.activeElement === lastEl) { e.preventDefault(); first.focus(); }
    }
    function open(trigger) {
      last = trigger || document.activeElement;
      el.hidden = false;
      void el.offsetWidth;
      el.classList.add('is-open');
      document.body.classList.add('drawer-open');
      el.addEventListener('keydown', key);
      var f = focusables(); (f[0] || panel).focus();
    }
    function close() {
      el.classList.remove('is-open');
      document.body.classList.remove('drawer-open');
      el.removeEventListener('keydown', key);
      setTimeout(function () { el.hidden = true; }, reduceMotion ? 0 : 300);
      if (last && last.focus) last.focus();
      if (onClose) onClose();
    }
    return { open: open, close: close, isOpen: function () { return !el.hidden; } };
  }

  /* ---------- Gallery: optional hover zoom + full-screen view (opens at 100%) ---------- */
  function initGallery(g) {
    if (g.dataset.ready) return;
    g.dataset.ready = '1';
    var area = g.querySelector('[data-zoom-area]');
    var main = g.querySelector('[data-main-image]');
    var thumbs = Array.prototype.slice.call(g.querySelectorAll('[data-thumb]'));
    var zoomOn = g.dataset.zoom === 'on';
    var hoverOn = g.dataset.hover === 'on';
    var hoverLevel = (parseInt(g.dataset.hoverZoom, 10) || 130) / 100;
    var maxZoom = Math.max(1.05, (parseInt(g.dataset.maxZoom, 10) || 150) / 100);
    var images = [];
    var data = g.querySelector('[data-gallery-images]');
    if (data) { try { images = JSON.parse(data.textContent); } catch (e) { images = []; } }

    function show(idx) {
      var b = thumbs[idx];
      g.dataset.index = idx;
      if (!b || !main) return;
      main.src = b.dataset.src;
      main.srcset = b.dataset.srcset || '';
      main.alt = b.dataset.alt || '';
      thumbs.forEach(function (x) { x.removeAttribute('aria-current'); });
      b.setAttribute('aria-current', 'true');
    }
    thumbs.forEach(function (b, idx) { b.addEventListener('click', function () { show(idx); }); });
    g.showMedia = function (mediaId) {
      var idx = thumbs.findIndex(function (b) { return String(b.dataset.mediaId) === String(mediaId); });
      if (idx > -1) show(idx);
    };
    if (!area || !main) return;

    /* Hover zoom on the page (off unless switched on in the theme editor) */
    var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    if (hoverOn && fine) {
      area.classList.add('is-hoverzoom');
      area.addEventListener('mouseenter', function () { area.classList.add('is-zooming'); main.style.transform = 'scale(' + hoverLevel + ')'; });
      area.addEventListener('mousemove', function (e) {
        var r = area.getBoundingClientRect();
        main.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
      });
      area.addEventListener('mouseleave', function () { area.classList.remove('is-zooming'); main.style.transform = ''; main.style.transformOrigin = ''; });
    }

    /* Full-screen view */
    var lb = g.querySelector('[data-lightbox]');
    if (!zoomOn || !lb || !images.length) return;
    area.classList.add('is-zoomable');
    document.body.appendChild(lb);
    var stage = lb.querySelector('[data-lb-stage]');
    var img = lb.querySelector('[data-lb-img]');
    var count = lb.querySelector('[data-lb-count]');
    var pct = lb.querySelector('[data-lb-pct]');
    var btnIn = lb.querySelector('[data-lb-in]'), btnOut = lb.querySelector('[data-lb-out]');
    var i = 0, z = 1, x = 0, y = 0;
    var m = modal(lb, lb);

    function clamp() {
      var w = img.offsetWidth * z, h = img.offsetHeight * z;
      var mx = Math.max(0, (w - stage.clientWidth) / 2), my = Math.max(0, (h - stage.clientHeight) / 2);
      x = Math.max(-mx, Math.min(mx, x));
      y = Math.max(-my, Math.min(my, y));
    }
    function apply(animate) {
      clamp();
      img.style.transition = animate && !reduceMotion ? 'transform .2s ease' : 'none';
      img.style.transform = 'translate(' + x + 'px,' + y + 'px) scale(' + z + ')';
      if (pct) pct.textContent = Math.round(z * 100) + '%';
      var had = document.activeElement;
      if (btnOut) btnOut.disabled = z <= 1.001;
      if (btnIn) btnIn.disabled = z >= maxZoom - 0.001;
      /* keep keyboard focus (and Escape) inside the viewer when a focused button becomes disabled */
      if (had && had.disabled) { var other = had === btnIn ? btnOut : btnIn; (other && !other.disabled ? other : lb.querySelector('[data-lb-close]')).focus(); }
      lb.classList.toggle('is-zoomed', z > 1.001);
    }
    /* Zoom towards a point on screen (cx, cy) */
    function zoomTo(nz, cx, cy, animate) {
      nz = Math.max(1, Math.min(maxZoom, nz));
      var r = stage.getBoundingClientRect();
      var px = (cx === undefined ? r.left + r.width / 2 : cx) - (r.left + r.width / 2);
      var py = (cy === undefined ? r.top + r.height / 2 : cy) - (r.top + r.height / 2);
      x = px - (px - x) * (nz / z);
      y = py - (py - y) * (nz / z);
      z = nz;
      if (z === 1) { x = 0; y = 0; }
      apply(animate);
    }
    function load(k) {
      i = (k + images.length) % images.length;
      var it = images[i];
      z = 1; x = 0; y = 0;
      img.src = it.src;
      img.alt = it.alt || '';
      if (count) count.textContent = (i + 1) + ' / ' + images.length;
      apply(false);
    }
    /* refit once the photo has loaded, and after resizing or rotating the device */
    img.addEventListener('load', function () { if (!lb.hidden) apply(false); });
    window.addEventListener('orientationchange', function () { setTimeout(function () { if (!lb.hidden) apply(false); }, 200); });
    area.addEventListener('click', function (e) {
      /* clear any hover zoom on the page photo so it never carries into the viewer */
      area.classList.remove('is-zooming'); main.style.transform = ''; main.style.transformOrigin = '';
      load(parseInt(g.dataset.index, 10) || 0);
      m.open(e.target.closest('button') || area.querySelector('[data-open-lightbox]') || area);
    });
    lb.querySelector('[data-lb-close]').addEventListener('click', m.close);
    if (btnIn) btnIn.addEventListener('click', function () { zoomTo(z * 1.15, undefined, undefined, true); });
    if (btnOut) btnOut.addEventListener('click', function () { zoomTo(z / 1.15, undefined, undefined, true); });
    var resetBtn = lb.querySelector('[data-lb-reset]');
    if (resetBtn) resetBtn.addEventListener('click', function () { zoomTo(1, undefined, undefined, true); });
    var prev = lb.querySelector('[data-lb-prev]'), next = lb.querySelector('[data-lb-next]');
    if (prev) prev.addEventListener('click', function () { load(i - 1); });
    if (next) next.addEventListener('click', function () { load(i + 1); });
    lb.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft' && z === 1) load(i - 1);
      if (e.key === 'ArrowRight' && z === 1) load(i + 1);
      if (e.key === '+' || e.key === '=') zoomTo(z * 1.25, undefined, undefined, true);
      if (e.key === '-') zoomTo(z / 1.25, undefined, undefined, true);
      if (e.key === '0') zoomTo(1, undefined, undefined, true);
    });
    window.addEventListener('resize', function () { if (!lb.hidden) apply(false); });

    /* Mouse wheel / trackpad: scroll up to zoom in, down to zoom out */
    stage.addEventListener('wheel', function (e) {
      e.preventDefault();
      var f = Math.exp(-e.deltaY * (e.ctrlKey ? 0.01 : 0.0025));
      zoomTo(z * f, e.clientX, e.clientY, false);
    }, { passive: false });
    stage.addEventListener('dblclick', function (e) { zoomTo(z > 1.001 ? 1 : 2, e.clientX, e.clientY, true); });

    /* Pointer: drag to move, two fingers to pinch, swipe to change photo at 100% */
    var pts = {}, startDist = 0, startZ = 1, last = null, swipeX = null, moved = false;
    function dist() { var k = Object.keys(pts); if (k.length < 2) return 0; var a = pts[k[0]], b = pts[k[1]]; return Math.hypot(a.x - b.x, a.y - b.y); }
    function mid() { var k = Object.keys(pts); var a = pts[k[0]], b = pts[k[1]]; return { x: (a.x + b.x) / 2, y: (a.y + b.y) / 2 }; }
    stage.addEventListener('pointerdown', function (e) {
      stage.setPointerCapture(e.pointerId);
      pts[e.pointerId] = { x: e.clientX, y: e.clientY };
      moved = false;
      if (Object.keys(pts).length === 2) { startDist = dist(); startZ = z; swipeX = null; }
      else { last = { x: e.clientX, y: e.clientY }; swipeX = z === 1 ? e.clientX : null; }
    });
    stage.addEventListener('pointermove', function (e) {
      if (!pts[e.pointerId]) return;
      pts[e.pointerId] = { x: e.clientX, y: e.clientY };
      var n = Object.keys(pts).length;
      if (n === 2 && startDist) {
        var c = mid();
        zoomTo(startZ * dist() / startDist, c.x, c.y, false);
        moved = true;
      } else if (n === 1 && last && z > 1) {
        x += e.clientX - last.x; y += e.clientY - last.y;
        last = { x: e.clientX, y: e.clientY };
        moved = true;
        apply(false);
      }
    });
    function up(e) {
      if (swipeX !== null && Object.keys(pts).length === 1 && z === 1) {
        var dx = e.clientX - swipeX;
        if (Math.abs(dx) > 50 && images.length > 1) load(dx < 0 ? i + 1 : i - 1);
      }
      delete pts[e.pointerId];
      if (Object.keys(pts).length < 2) startDist = 0;
      var rest = Object.keys(pts);
      last = rest.length ? pts[rest[0]] : null;
      swipeX = null;
    }
    stage.addEventListener('pointerup', up);
    stage.addEventListener('pointercancel', up);
  }

  /* ---------- Product: variants, swatches, quantity ---------- */
  function initProduct(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    var gallery = root.querySelector('[data-gallery]');
    if (gallery) initGallery(gallery);
    root.querySelectorAll('[data-qty]').forEach(function (q) {
      var input = q.querySelector('input');
      q.querySelectorAll('button').forEach(function (b) {
        b.addEventListener('click', function () {
          var v = parseInt(input.value, 10) || 1;
          v = b.dataset.step === 'up' ? v + 1 : Math.max(1, v - 1);
          input.value = v;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
    var json = root.querySelector('[data-product-json]');
    if (!json) return;
    var product;
    try { product = JSON.parse(json.textContent); } catch (e) { return; }
    var selects = Array.prototype.slice.call(root.querySelectorAll('[data-option-index]'));
    var idInput = root.querySelector('form[action*="/cart/add"] input[name="id"]');
    var priceEl = root.querySelector('[data-price]');
    var compareEl = root.querySelector('[data-compare]');
    var addBtn = root.querySelector('button[name="add"]');
    var stock = root.querySelector('[data-stock]');
    var fmt = root.dataset.moneyFormat || '€{{amount_with_comma_separator}}';
    var notes = root.querySelector('[data-colour-notes]');
    function handleize(t) { return String(t).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, ''); }
    function showColourNote(v) {
      if (!notes) return;
      var ci = parseInt(notes.dataset.colourIndex, 10);
      if (isNaN(ci) || ci < 0 || !v.options[ci]) return;
      var key = handleize(v.options[ci]);
      notes.querySelectorAll('[data-colour]').forEach(function (p) { p.hidden = p.dataset.colour !== key; });
    }
    root.querySelectorAll('[data-swatch]').forEach(function (b) {
      b.addEventListener('click', function () {
        var sel = document.getElementById(b.dataset.swatchFor);
        if (!sel) return;
        sel.value = b.dataset.swatch;
        root.querySelectorAll('[data-swatch-for="' + b.dataset.swatchFor + '"]').forEach(function (x) {
          x.setAttribute('aria-pressed', String(x === b));
        });
        var cur = b.closest('.field').querySelector('[data-swatch-current]');
        if (cur) cur.textContent = b.dataset.swatch;
        sel.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
    function money(cents) {
      var v = (cents / 100).toFixed(2);
      var parts = v.split('.');
      var withComma = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1];
      var plain = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
      return fmt.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withComma)
                .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, parts[0])
                .replace(/\{\{\s*amount_no_decimals\s*\}\}/, parts[0])
                .replace(/\{\{\s*amount\s*\}\}/, plain);
    }
    function updateStock(v) {
      if (!stock) return;
      var low = parseInt(stock.dataset.low, 10) || 3;
      var q = v.inventory_quantity;
      if (!v.available) { stock.textContent = ''; return; }
      if (v.inventory_management === 'shopify' && typeof q === 'number' && q > 0 && q <= low) {
        stock.textContent = stock.dataset.labelLow.replace('__n__', q);
      } else {
        stock.textContent = stock.dataset.showIn === 'true' ? stock.dataset.labelIn : '';
      }
    }
    selects.forEach(function (s) {
      s.addEventListener('change', function () {
        var opts = selects.map(function (x) { return x.value; });
        var v = product.variants.find(function (vv) {
          return vv.options.every(function (o, k) { return o === opts[k]; });
        });
        if (!v) {
          if (addBtn) { addBtn.disabled = true; addBtn.textContent = addBtn.dataset.unavailable; }
          return;
        }
        if (idInput) idInput.value = v.id;
        showColourNote(v);
        updateStock(v);
        if (priceEl) priceEl.textContent = money(v.price);
        if (compareEl) compareEl.textContent = v.compare_at_price > v.price ? money(v.compare_at_price) : '';
        if (addBtn) {
          addBtn.disabled = !v.available;
          addBtn.textContent = v.available ? addBtn.dataset.add : addBtn.dataset.soldout;
        }
        if (v.featured_media && gallery && gallery.showMedia) gallery.showMedia(v.featured_media.id);
        if (!root.closest('[data-quick-view]')) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        }
      });
    });
  }

  /* ---------- Cart page: quantity steppers submit the form ---------- */
  function initCart(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    root.querySelectorAll('[data-qty]').forEach(function (q) {
      var input = q.querySelector('input');
      q.querySelectorAll('button').forEach(function (b) {
        b.addEventListener('click', function () {
          var v = parseInt(input.value, 10) || 0;
          v = b.dataset.step === 'up' ? v + 1 : Math.max(0, v - 1);
          input.value = v;
          root.submit();
        });
      });
      input.addEventListener('change', function () { root.submit(); });
    });
  }

  /* ---------- Cart drawer + add to cart without leaving the page ---------- */
  var cartDrawer = (function () {
    var el = document.querySelector('[data-cart-drawer]');
    if (!el) return null;
    var panel = el.querySelector('[data-cart-drawer-panel]');
    var m = modal(el, panel, function () {
      document.querySelectorAll('[data-cart-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    });
    function render(html) {
      if (!html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-cart-drawer-inner]');
      var cur = panel.querySelector('[data-cart-drawer-inner]');
      if (fresh && cur) cur.replaceWith(fresh);
      var n = fresh ? parseInt(fresh.dataset.count, 10) || 0 : 0;
      document.querySelectorAll('[data-cart-count]').forEach(function (c) { c.textContent = n; c.hidden = n === 0; });
      if (fresh) document.querySelectorAll('[data-cart-count-label]').forEach(function (c) { c.textContent = fresh.dataset.countLabel; });
    }
    function sectionId() {
      var s = panel.querySelector('.shopify-section');
      return s ? s.id.replace('shopify-section-', '') : 'cart-drawer';
    }
    function change(line, qty) {
      panel.classList.add('is-busy');
      return fetch((HH.routes.cartChange || '/cart/change') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: qty, sections: [sectionId()] })
      }).then(function (r) { return r.json(); })
        .then(function (d) { if (d.sections) render(d.sections[sectionId()]); })
        .finally(function () { panel.classList.remove('is-busy'); });
    }
    panel.addEventListener('click', function (e) {
      var b = e.target.closest('[data-cart-qty]');
      if (b) { change(parseInt(b.dataset.line, 10), parseInt(b.dataset.cartQty, 10)); return; }
      if (e.target.closest('[data-cart-close]')) m.close();
    });
    el.querySelector('.cdrawer__overlay').addEventListener('click', m.close);
    document.querySelectorAll('[data-cart-open]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        b.setAttribute('aria-expanded', 'true');
        m.open(b);
      });
    });
    return { open: m.open, close: m.close, render: render, sectionId: sectionId };
  })();

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!cartDrawer || HH.cartType !== 'drawer') return;
    if (!form.matches || !form.matches('form[action*="/cart/add"]')) return;
    e.preventDefault();
    var btn = form.querySelector('button[name="add"]') || (e.submitter);
    var err = form.querySelector('[data-form-error]');
    if (err) { err.hidden = true; err.textContent = ''; }
    if (btn) { btn.disabled = true; btn.classList.add('is-loading'); }
    var fd = new FormData(form);
    fd.append('sections', cartDrawer.sectionId());
    fd.append('sections_url', window.location.pathname);
    fetch((HH.routes.cartAdd || '/cart/add') + '.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (!res.ok || res.d.status) {
          if (err) { err.textContent = res.d.description || res.d.message || HH.strings.error; err.hidden = false; }
          return;
        }
        if (res.d.sections) cartDrawer.render(res.d.sections[cartDrawer.sectionId()]);
        if (quickView && quickView.isOpen()) quickView.close();
        cartDrawer.open(btn);
      })
      .catch(function () { if (err) { err.textContent = HH.strings.error; err.hidden = false; } })
      .finally(function () { if (btn) { btn.disabled = false; btn.classList.remove('is-loading'); } });
  });

  /* ---------- Quick view ---------- */
  var quickView = (function () {
    var el = document.querySelector('[data-quick-view]');
    if (!el) return null;
    var panel = el.querySelector('.qview__panel');
    var body = el.querySelector('[data-qv-body]');
    var m = modal(el, panel, function () { setTimeout(function () { body.innerHTML = ''; }, 320); });
    el.querySelectorAll('[data-qv-close]').forEach(function (b) { b.addEventListener('click', m.close); });
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-quick-view-open]');
      if (!b) return;
      e.preventDefault();
      body.innerHTML = '<p class="qview__loading">' + (HH.strings.loading || '…') + '</p>';
      m.open(b);
      var url = b.dataset.url + (b.dataset.url.indexOf('?') > -1 ? '&' : '?') + 'section_id=quick-view';
      fetch(url).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var qv = doc.querySelector('.qv');
        if (!qv) { window.location.href = b.dataset.url; return; }
        body.innerHTML = '';
        body.appendChild(qv);
        initProduct(qv);
        var t = body.querySelector('#QuickViewTitle'); if (t) t.setAttribute('tabindex', '-1');
        (body.querySelector('select,button') || panel).focus();
      }).catch(function () { window.location.href = b.dataset.url; });
    });
    return { close: m.close, isOpen: m.isOpen };
  })();

  /* ---------- Predictive search ---------- */
  (function () {
    var panel = document.querySelector('[data-search-panel]');
    if (!panel) return;
    var input = panel.querySelector('[data-search-input]');
    var results = panel.querySelector('[data-search-results]');
    var openers = document.querySelectorAll('[data-search-open]');
    var timer = null, ctrl = null, last = null;
    function open(e) {
      if (e) e.preventDefault();
      last = document.activeElement;
      panel.hidden = false;
      openers.forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
      input.focus();
    }
    function close() {
      panel.hidden = true;
      openers.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      input.setAttribute('aria-expanded', 'false');
      if (last && last.focus) last.focus();
    }
    openers.forEach(function (b) { b.addEventListener('click', open); });
    panel.querySelector('[data-search-close]').addEventListener('click', close);
    panel.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { close(); return; }
      var links = Array.prototype.slice.call(results.querySelectorAll('a'));
      if (!links.length || (e.key !== 'ArrowDown' && e.key !== 'ArrowUp')) return;
      e.preventDefault();
      var k = links.indexOf(document.activeElement);
      k = e.key === 'ArrowDown' ? k + 1 : k - 1;
      if (k < 0) { input.focus(); return; }
      links[Math.min(k, links.length - 1)].focus();
    });
    document.addEventListener('click', function (e) {
      if (!panel.hidden && !panel.contains(e.target) && !e.target.closest('[data-search-open]')) close();
    });
    input.addEventListener('input', function () {
      var q = input.value.trim();
      clearTimeout(timer);
      if (!q) { results.innerHTML = ''; input.setAttribute('aria-expanded', 'false'); return; }
      timer = setTimeout(function () {
        if (ctrl) ctrl.abort();
        ctrl = 'AbortController' in window ? new AbortController() : null;
        var url = (input.dataset.url || '/search/suggest') + '?q=' + encodeURIComponent(q) +
          '&resources[type]=product,collection,page,article,query&resources[limit]=10&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,tag,vendor,body&section_id=predictive-search';
        fetch(url, ctrl ? { signal: ctrl.signal } : {}).then(function (r) { return r.text(); }).then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var box = doc.querySelector('.psearch__results');
          results.innerHTML = box ? box.outerHTML : '';
          input.setAttribute('aria-expanded', box ? 'true' : 'false');
        }).catch(function () {});
      }, 220);
    });
  })();

  /* ---------- Sticky header: hide on scroll down, show on scroll up ---------- */
  (function () {
    var h = document.querySelector('[data-header]');
    if (!h) return;
    var root = document.documentElement;
    function setH() { root.style.setProperty('--header-h', h.offsetHeight + 'px'); }
    setH();
    window.addEventListener('resize', setH);
    if (h.dataset.sticky !== 'scroll-up') return;
    var lastY = window.scrollY, ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var y = window.scrollY;
        var down = y > lastY && y > h.offsetHeight * 2;
        var searchOpen = document.querySelector('[data-search-panel]:not([hidden])');
        h.classList.toggle('is-hidden', down && !searchOpen);
        lastY = y;
        ticking = false;
      });
    }, { passive: true });
  })();

  /* ---------- How-it's-made films: muted until sound is turned on ---------- */
  var films = [];
  function initFilm(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    var v = root.querySelector('video');
    if (!v) return;
    var start = root.querySelector('[data-film-start]');
    var muteBtn = root.querySelector('[data-film-mute]');
    var vol = root.querySelector('[data-film-volume]');
    var state = root.querySelector('[data-film-state]');
    var lastVol = 0.7;
    v.muted = true;
    v.removeAttribute('autoplay');
    v.removeAttribute('controls');
    v.volume = 0;
    films.push({ root: root, v: v, stop: stopAll });

    function sync() {
      var on = !v.paused && !v.muted && v.volume > 0;
      root.classList.toggle('is-playing', on);
      if (on) root.classList.add('has-played');
      muteBtn.setAttribute('aria-pressed', String(!on));
      muteBtn.setAttribute('aria-label', on ? muteBtn.dataset.labelMute : muteBtn.dataset.labelUnmute);
      vol.value = on ? v.volume : 0;
      vol.style.setProperty('--vol', (on ? v.volume : 0) * 100 + '%');
      if (state) state.textContent = on ? (state.dataset.playing || '') : (state.dataset.muted || state.textContent);
    }
    if (state) { state.dataset.muted = state.textContent; state.dataset.playing = (window.HH && HH.strings && HH.strings.playing) || ''; }
    function soundOn(level) {
      films.forEach(function (f) { if (f.v !== v) { f.v.pause(); f.v.muted = true; } });
      v.volume = level;
      v.muted = false;
      var p = v.play();
      if (p && p.catch) p.catch(function () { v.muted = true; sync(); });
      sync();
    }
    function soundOff() {
      if (v.volume > 0) lastVol = v.volume;
      v.muted = true;
      v.pause();
      sync();
    }
    function stopAll() { soundOff(); }
    start.addEventListener('click', function () { soundOn(lastVol); muteBtn.focus(); });
    muteBtn.addEventListener('click', function () {
      if (v.muted || v.paused || v.volume === 0) soundOn(lastVol); else soundOff();
    });
    vol.addEventListener('input', function () {
      var x = parseFloat(vol.value);
      if (x > 0) { lastVol = x; soundOn(x); } else { soundOff(); }
    });
    v.addEventListener('click', function () { if (v.muted || v.paused) soundOn(lastVol); else soundOff(); });
    v.addEventListener('play', sync);
    v.addEventListener('pause', sync);
    v.addEventListener('volumechange', sync);
    v.addEventListener('ended', function () {
      v.muted = true; v.currentTime = 0;
      root.classList.remove('has-played');
      sync();
    });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (!e.isIntersecting && !v.paused) soundOff(); });
      }, { threshold: 0.2 }).observe(root);
    }
    sync();
  }

  /* ---------- Share ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-share]');
    if (!b) return;
    if (navigator.share) { navigator.share({ title: b.dataset.title, url: b.dataset.url }).catch(function () {}); return; }
    if (navigator.clipboard) navigator.clipboard.writeText(b.dataset.url).then(function () {
      var t = b.textContent; b.textContent = b.dataset.copied; setTimeout(function () { b.textContent = t; }, 1800);
    });
  });

  /* ---------- Account panel ---------- */
  (function () {
    var wrap = document.querySelector('[data-acct]');
    if (!wrap) return;
    var btn = wrap.querySelector('[data-acct-open]');
    var panel = wrap.querySelector('.acct__panel');
    function set(open) {
      panel.hidden = !open;
      btn.setAttribute('aria-expanded', String(open));
      if (open) { var f = panel.querySelector('a'); if (f) f.focus(); }
    }
    btn.addEventListener('click', function (e) { e.preventDefault(); set(panel.hidden); });
    document.addEventListener('click', function (e) { if (!panel.hidden && !wrap.contains(e.target)) set(false); });
    wrap.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !panel.hidden) { set(false); btn.focus(); } });
  })();

  /* ---------- Language dropdown ---------- */
  (function () {
    document.querySelectorAll('[data-lang]').forEach(function (wrap) {
      var btn = wrap.querySelector('[data-lang-open]');
      var list = wrap.querySelector('.lang__list');
      if (!btn || !list) return;
      function opts() { return Array.prototype.slice.call(list.querySelectorAll('.lang__opt')); }
      function set(open, focusFirst) {
        list.hidden = !open;
        btn.setAttribute('aria-expanded', String(open));
        if (open && focusFirst) {
          var cur = list.querySelector('[aria-current="true"]') || opts()[0];
          if (cur) cur.focus();
        }
      }
      btn.addEventListener('click', function (e) { e.preventDefault(); set(list.hidden, e.detail === 0); });
      document.addEventListener('click', function (e) { if (!list.hidden && !wrap.contains(e.target)) set(false); });
      wrap.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !list.hidden) { set(false); btn.focus(); return; }
        if (e.key === 'ArrowDown' && e.target === btn) { e.preventDefault(); set(true, true); return; }
        if ((e.key === 'ArrowDown' || e.key === 'ArrowUp') && !list.hidden) {
          var o = opts(), k = o.indexOf(document.activeElement);
          if (k > -1) { e.preventDefault(); o[(k + (e.key === 'ArrowDown' ? 1 : o.length - 1)) % o.length].focus(); }
        }
      });
      wrap.addEventListener('focusout', function (e) { if (!list.hidden && !wrap.contains(e.relatedTarget)) set(false); });
    });
  })();

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-carousel]').forEach(initCarousel);
    (scope || document).querySelectorAll('[data-tabs]').forEach(initTabs);
    (scope || document).querySelectorAll('[data-product]').forEach(initProduct);
    (scope || document).querySelectorAll('[data-cart-form]').forEach(initCart);
    (scope || document).querySelectorAll('[data-film]').forEach(initFilm);
  }
  initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
